import {formatNumber} from '@hconnect/common/utils'
import {CardBox, StyledColumn, StyledTitle} from '@hconnect/uikit/src/lib2'
import {Grid, Stack, Typography} from '@mui/material'
import {KPI_ICONS_MAP, DeltaLabel, kpiDeltaReversedColorMap} from '@widgets/kpis'
import {camelCase} from 'lodash'
import React from 'react'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../consts'
import {type KpiTableData} from '../types'

type PlantKpiMobileGridsProps = {
  kpiTableData: KpiTableData[]
  formattedDate: string
}

export const KpiGrid: React.FC<{kpiData: KpiTableData; formattedDate: string}> = ({
  kpiData,
  formattedDate
}) => {
  const {t, i18n} = useTranslation(FEATURE_NAMESPACE)

  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      spacing={2}
      data-test-id="plant-kpi-mobile-grid"
    >
      <StyledColumn>
        <StyledTitle variant="caption">
          {t('plantKpi.label.planned', {date: formattedDate})}
        </StyledTitle>
        <Typography variant="h4">
          {formatNumber(kpiData.data?.planned ?? 0, i18n.language)}
          {kpiData.data?.unit && ` ${kpiData.data.unit}`}
        </Typography>
      </StyledColumn>
      <StyledColumn>
        <StyledTitle variant="caption">
          {t('plantKpi.label.actual', {date: formattedDate})}
        </StyledTitle>
        <Typography variant="h4">
          {formatNumber(kpiData.data?.actual ?? 0, i18n.language)}
          {kpiData.data?.unit && ` ${kpiData.data.unit}`}
        </Typography>
      </StyledColumn>
      <StyledColumn>
        <StyledTitle variant="caption">{t('plantKpi.label.delta')}</StyledTitle>
        <Typography variant="h4">
          <DeltaLabel
            value={kpiData.data?.delta || 0}
            reverseColor={kpiDeltaReversedColorMap[kpiData.name]}
          />
        </Typography>
      </StyledColumn>
    </Stack>
  )
}

export const PlantKpiMobileGrids: React.FC<PlantKpiMobileGridsProps> = ({
  kpiTableData,
  formattedDate
}) => {
  const {t} = useTranslation()

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography variant="h3" display="flex" alignItems="center" m={1.5}>
          {t('plantKpi.label.janusMonthlyKPIs')}
        </Typography>
        <Grid container spacing={2}>
          {kpiTableData.map((kpiData) => (
            <Grid item xs={12} key={kpiData.name}>
              <CardBox px={1.5}>
                <Typography variant="h3" display="flex" alignItems="center" mb={2} gap={1}>
                  {KPI_ICONS_MAP[kpiData.name]}
                  {t(`actualVsPlanned.plantKpis.${camelCase(kpiData.name)}`)}
                </Typography>
                <KpiGrid kpiData={kpiData} formattedDate={formattedDate} />
              </CardBox>
            </Grid>
          ))}
        </Grid>
      </Grid>
    </Grid>
  )
}
